<template>
  <div
    class="app flex-row align-items-center"
    v-if="
      $route.path.includes('Manager') ||
      $route.path.includes('shop') ||
      $route.path.includes('sales')
    "
  >
    <div class="container">
      <v-row class="justify-content-center">
        <v-col md="12">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">404</h1>
            <h4 class="font-weight-bold shopPrimary--text fs-large pt-3">
              صفحه مورد نظر شما پیدا نشد
            </h4>
            <b-btn class="btn btn-dark me-1 ms-1" @click="gotoHome()">
              بازگشت به خانه
            </b-btn>
            <b-btn class="btn btn-warning me-1 ms-1" @click="goBack()">
              بازگشت به صفحه قبل
            </b-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
  <div v-else>
    <v-card class="common-card" style="height: 100vh">
      <v-card-text>
        <v-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
          sm="12"
          xs="12"
          class="d-flex justify-center align-self-center"
        >
          <div class="image-container">
            <img class="image" src="/not.svg" alt="" />
          </div>
        </v-col>
        <v-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
          sm="12"
          xs="12"
          class="d-flex justify-center align-self-center"
        >
          <div class="text-center my-3">
            <span class="font-weight-bold shopPrimary--text fs-large"
              >صفحه مورد نظر یافت نشد</span
            >
          </div>
        </v-col>
        <v-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
          sm="12"
          xs="12"
          class="d-flex justify-center align-self-center"
        >
          <div class="d-flex flex-sm-row flex-column justify-center mt-5">
            <v-btn
              width="200"
              height="45"
              class="shopPrimary white--text mx-auto mx-sm-1 mb-sm-0 mb-4"
              @click="gotoShopHome()"
            >
              بازگشت به صفحه اصلی
            </v-btn>
            <v-btn
              width="200"
              height="45"
              class="shopPrimary--text mx-auto mx-sm-1"
              @click="goBack()"
              outline
            >
              بازگشت به صفحه قبل
            </v-btn>
          </div>
        </v-col>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import router from "../router";
export default {
  name: "Page404",

  methods: {
    gotoHome() {
      this.$router.push("/" + localStorage.role + "/dashboard");
    },
    gotoShopHome() {
      this.$router.push("/");
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.image-container {
  width: 500px;
  height: auto;
  img {
    width: 100%;
    height: 100%;
  }
  @media only screen and (max-width: 1300px) {
    width: 300px;
    height: auto;
  }
}
</style>
